<script setup lang="ts">
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import type { PaletteColorProp } from '#imports';

const {
    hideMenu,
    menuColor = 'white',
    backgroundColor = 'transparent',
    sticky,
    showBack,
} = defineProps<IProps>();

const MrbilitIcon = defineAsyncComponent(() => import('./MrbilitIcon.vue'));
const AirplaneTicketIcon = defineAsyncComponent(
    () => import('./AirplaneTicketIcon.vue')
);

interface IProps {
    showBack?: boolean;
    sticky?: boolean;
    hideMenu?: boolean;
    backgroundColor?: PaletteColorProp | string;
    menuColor?: 'blue' | 'white';
}
const { isAirplaneTicket } = useWhiteLabel();
const router = useRouter();
const route = useRoute();
const backBtn = () => {
    const url = window.opener?.location?.href
        ? new URL(window.opener?.location?.href)
        : null;
    const { redirect } = history.state;
    const queryParam = url?.searchParams.size ? `?${url?.searchParams}` : '';
    const openerUrl = `${url?.pathname || ''}${queryParam}`;
    switch (true) {
        case !!router.options.history.state.back:
            router.back();
            break;
        case !!window.opener?.location?.href && route.fullPath !== openerUrl:
            router.replace(openerUrl);
            break;
        case !!redirect:
            router.replace(redirect);
            break;
        default:
            router.replace('/');
            break;
    }
};
</script>

<template>
    <div class="header-container">
        <div class="header-wrapper container" :class="{ sticky }">
            <!-- why not listen to slot and then showBack ? -->
            <div v-if="showBack" class="back-button-container">
                <slot name="right-icon">
                    <mr-button
                        v-if="showBack"
                        :left-icon="{ icon: faArrowRight, color: 'white' }"
                        size="big"
                        @click.stop="backBtn()"
                    />
                </slot>
            </div>
            <div v-else class="place-holder" />
            <div id="portal-title" class="title">
                <div>
                    <AirplaneTicketIcon
                        v-if="isAirplaneTicket"
                        :color="menuColor"
                    />
                    <MrbilitIcon v-else :color="menuColor" />
                </div>
            </div>
            <div class="close-button-container">
                <div v-if="!hideMenu" class="place-holder" />
                <slot v-else name="left-icon" />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.header-container {
    display: flex;
    align-items: flex-end;
    width: 100%;
    margin: auto;
    z-index: 1000;
    height: 100%;
}

.burger-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    z-index: 11000;
    background: black;
    opacity: 0.6;
}

@media (max-width: $app-mobile-max-width) {
    .header-wrapper {
        display: grid;
        grid-template-columns: 0.2fr 1fr 0.2fr;
        align-items: center;
        margin: auto;
        position: relative;
        height: 100%;
        background-color: v-bind(backgroundColor);
    }
    .back-button-container {
        display: flex;
    }

    .close-button-container {
        display: flex;
        align-items: center;
        .place-holder {
            width: 55px;
        }
    }

    .sticky {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        height: 62px;
        z-index: 10000;
    }

    .title {
        @include tg-display4($w5, white);
        display: flex;
        align-items: center;
        justify-content: center;
        :deep() {
            > * {
                display: none;
                &:last-child {
                    display: flex;
                }
            }
        }
    }
}
</style>
